import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const Audio = ({ url }) => {
    return (_jsx(_Fragment, { children: _jsx("audio", { className: "block w-full max-w-md rounded", controls: true, src: url }) }));
};
